import { memo } from 'react';
const SvgFilter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="filter_svg__feather filter_svg__feather-filter"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
  </svg>
);
const Memo = memo(SvgFilter);
export default Memo;
